import core from "@/helpers/client";
const productCatalogService = {  
    async getProductCatalogListAsync(params) {
      const result = await core.fetch(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/CatalogProducts`,
        params
      )
      return result
    },   
    async updateProductCatalogAsync(id, model) {
      const result = await core.update(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/CatalogProducts/${id}`,
        model
      );
      return result;
    },
    async deleteProductAllCatalogAsync(id) {
      const result = await core.remove(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/CatalogProducts/${id}`
      );
      return result;
    },
  }
  export default productCatalogService